/**
 * Display URL for an account: the verified `website` when enrichment has set
 * one, otherwise the first resolved domain. Bare domains are fine — both
 * `logoUrl()` and `normalizeExternalUrl()` accept them.
 */
export function accountWebsite(account: {
  website?: string | null;
  domains?: string[] | null;
}): string | null {
  return account.website?.trim() || account.domains?.[0] || null;
}
